import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import NoProductAssignedPage from "../routes/accounts/no-product-assigned-page";
import User from "../routes/accounts/user/user";
import Error from "./../routes/404";
import Loader from "./Loader";

const Accounts = React.lazy(() => import("../routes/accounts"));
const Login = React.lazy(() => import("../routes/accounts/login/login"));
const Logout = React.lazy(() => import("../routes/accounts/logout"));
const ResetPassword = React.lazy(() => import("../routes/accounts/reset/reset-password"));
const Reset = React.lazy(() => import("../routes/accounts/reset/reset"));
const ResetEmail = React.lazy(() => import("../routes/accounts/reset/reset-verify"));
const ResetSuccess = React.lazy(() => import("../routes/accounts/reset/reset-success"));
const FaceProblem = React.lazy(() => import("./../routes/accounts/face-problem"));
const UnsubEmail = React.lazy(() => import("./../routes/accounts/reset/unsubscribe-email"));
const Feedback = React.lazy(() => import("../routes/accounts/reset/unsubscribe-feedback"));

export default function Routes() {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/" component={Login}></Route>
          <Route exact path="/accounts" component={Accounts}></Route>
          <Route exact path="/signin" render={(props) => <Login key="login" {...props} />} />
          <Route exact path="/signin-sso" render={(props) => <Login key="sso" isSSO={true} {...props} />} />
          <Route exact path="/accounts/reset" component={Reset}></Route>
          <Route exact path="/accounts/reset-password" component={ResetPassword}></Route>
          <Route exact path="/accounts/reset-password-success" component={ResetSuccess}></Route>
          <Route exact path="/accounts/reset-email" component={ResetEmail}></Route>
          <Route exact path="/user" component={User}></Route>
          <Route exact path="/user/salesforce-status" component={User}></Route>
          <Route exact path="/user/hubspot-status" component={User}></Route>
          <Route exact path="/user/zoho-status" component={User}></Route>
          <Route exact path="/assign-new-product" component={NoProductAssignedPage}></Route>
          <Route exact path="/signout" component={Logout}></Route>
          <Route exact path="/unsubscribe-email" component={UnsubEmail}></Route>
          <Route exact path="/feedback" component={Feedback}></Route>
          <Route exact path="/facing-difficulties" component={FaceProblem}></Route>
          <Route exact path="/404" component={Error}></Route>
          <Route component={Error} />
        </Switch>
      </Suspense>
    </Router>
  );
}
